
export class DutiesDivPlanGoodsSearchConditionModel {

  // 共通
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** サイト区分 */
  public stockLimitFlg = String('');
  /** ページ番号 */
  public pageNo: number;
  /** ソートキー */
  public sortKey = String('');
  /** ソート順 */
  public orderKey = String('');

  // 通常検索タブ
  /**  Ｐコード */
  public pcode = String('');
  /** アイテムコード */
  public itemCode = String('');
  /** 仕様書コード */
  public ebaseSpecCode = String('');
  /** データ種別 */
  public dataType = String('');
  /** JANコード */
  public janCode = String('');
  /** メーカ名 */
  public makerName = String('');
  /** 商品案内用商品名 */
  public guideGoodsNameList: Array<any> = [];
  /** 商品案内用規格名 */
  public guideStandardNameList: Array<any> = [];
  /** 業態区分（ウィークリー）*/
  public dutiesFormWeeklyDiv = String('');
  /** 業態区分（デイリー）*/
  public dutiesFormDailyDivList: Array<any> = [];
  /** 業態区分（スポット）*/
  public dutiesFormSpotDiv = String('');
  /** 発注先コード */
  public ordrClientCode = String('');
  /** 発注先名称 */
  public ordrClientKanji = String('');
  /** 支払先コード */
  public payeeClientCode = String('');
  /** 支払先名称 */
  public payeeClientKanji = String('');
  /** 部門コード */
  public classCode = String('');
  /** 中分類コード */
  public middleClassCode = String('');
  /** 小分類コード */
  public smallClassCode = String('');
  /** 商品マスタ登録日From */
  public registDateFrom = String('');
  /** 商品マスタ登録日To */
  public registDateTo = String('');
  /** 商品マスタ更新日From */
  public updateDateFrom = String('');
  /** 商品マスタ更新日To */
  public updateDateTo = String('');
  /** 生協コード */
  public coopCodeList: Array<any> = [];
  /** 登録レベル */
  public admitStatus = String('');
  /** バイヤーコード */
  public buyerCode = String('');
  /** 商品区分 */
  public goodsDiv = String('');
  /** 取扱終了商品を含む */
  public dataKbnFlg = false;
  /** タグID */
  public tagIdList: Array<any> = [];
  /** タグ検索方法 */
  public tagSearchType = String('');
  /** マークコード */
  public goodsMarkList: Array<any> = [];
  /** 商品マーク検索方法 */
  public goodsMarkSearchType = String('');

  // リスト検索タブ
  /** Ｐコードリスト */
  public pcodeList: Array<any> = [];
  /** アイテムコードリスト */
  public itemCodeList: Array<any> = [];
}
